import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagGR(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURRdjshpqvfv7+/X19fHx8V8x6goAAAEnSURBVDjL3VDbkcNACIMO2A5uTAMe2AIys+6/ppNY2+c8Jj/3lcheWCMhSKQVlmVpL2HyiYLlAT+fIXgoPP/MVwJrWqc1vRc4BAqQ4cFNIAhfosBsaCVjAF3gEFT8jQCnpEi26VDmvov0XGImEytggNVq7hGHW3rmOgUt3MU4GZugHMmI6fgfuLUKHEirYFRwoAfD6WAeSQfViIRBZJTLAoHiMUEZPmZCbzTieGlXIW+atYOI5R2cDkoPiMFii9lQUYAKTBAjktAzcjeRcoCzJ2u8i+zExUHgkEdtJ/QcU6USHH1n/5PDS+R7rDKy53gsH4UOQU4FzvmOgbR/rdLHRimwDZQ76WTqFTGi57aBY2VMZV1HXftNJrtdcP0YN/kObO9x+7/gF9hmlT8gdsd4AAAAAElFTkSuQmCC",
    alt: "GR"
  }, props));
}